import React, { useState, useEffect } from "react";
import { Form, Button, Alert, Modal } from "react-bootstrap";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";

import "react-phone-number-input/style.css";
import imgUnCheck from "../../images/uncheck.svg";
import imgCheck from "../../images/check.svg";
import axios from 'axios';

const PrivacyPolicyModal = ({ show, onHide }) => (
  <Modal show={show} onHide={onHide} centered size="lg" aria-labelledby="privacyPolicyTitle">
    <Modal.Header closeButton>
      <Modal.Title id="privacyPolicyTitle">Политика конфиденциальности</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <h5>1. Общие положения</h5>
      <p>
        Настоящая Политика описывает, как сайт <strong>Varetus.com</strong> обрабатывает персональные данные
        пользователей формы обратной связи и иных веб-форм. Мы руководствуемся принципами необходимости,
        законности, прозрачности и минимизации данных.
      </p>

      <h5>2. Состав обрабатываемых данных</h5>
      <p>
        При отправке формы мы можем обрабатывать: имя, адрес электронной почты, номер телефона, содержимое
        сообщения, а также технические данные (IP-адрес, user-agent, реферер, параметры устройства, cookies).
        Данные указываются пользователем добровольно, за исключением технических данных, собираемых автоматически
        для функционирования сервиса, обеспечения безопасности и аналитики.
      </p>

      <h5>3. Цели обработки</h5>
      <ul>
        <li>Идентификация обращений и коммуникация с пользователем;</li>
        <li>Подготовка консультаций и ответов на запросы;</li>
        <li>Исполнение пользовательских запросов и улучшение качества сервиса;</li>
        <li>Аналитика использования сайта и предотвращение злоупотреблений;</li>
        <li>Соблюдение требований применимого права (включая хранение логов обращений).</li>
      </ul>

      <h5>4. Правовые основания</h5>
      <p>
        Обработка осуществляется на основании добровольного волеизъявления пользователя (отправка формы),
        а также на основании законного интереса владельца сайта — предоставлять и улучшать сервис,
        обеспечивать его безопасность и надёжность.
      </p>

      <h5>5. Передача и хранение данных</h5>
      <p>
        Данные могут храниться во внутренней инфраструктуре и/или у квалифицированных поставщиков
        облачных и почтовых сервисов. Мы применяем организационные и технические меры защиты, включая
        разграничение доступа, шифрование каналов связи и аудит событий безопасности.
      </p>

      <h5>6. Сроки обработки</h5>
      <p>
        Данные хранятся не дольше, чем это необходимо для целей, указанных в настоящей Политике, после чего
        удаляются или анонимизируются. Отдельные сведения могут храниться дольше, если это требуется законом
        или необходимо для защиты прав и законных интересов.
      </p>

      <h5>7. Права пользователя</h5>
      <ul>
        <li>Получать информацию об обработке своих данных;</li>
        <li>Запрашивать уточнение, обновление или удаление предоставленных данных в пределах закона;</li>
        <li>Ограничивать обработку и возражать против отдельной обработки, если такое право предоставлено законом;</li>
        <li>Отзывать согласие на обработку данных, если обработка основана на согласии.</li>
      </ul>

      <h5>8. Cookies и аналитика</h5>
      <p>
        Мы можем использовать cookies и схожие технологии для персонализации интерфейса, аналитики трафика и
        улучшения производительности. Пользователь может управлять cookies в настройках браузера; ограничение
        cookies может повлиять на корректность работы отдельных функций сайта.
      </p>

      <h5>9. Обновления Политики</h5>
      <p>
        Политика может периодически обновляться для отражения изменений сервиса и требований законодательства.
        Актуальная версия всегда доступна на сайте <strong>Varetus.com</strong>.
      </p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onHide}>Закрыть</Button>
    </Modal.Footer>
  </Modal>
);

const TermsModal = ({ show, onHide }) => (
  <Modal show={show} onHide={onHide} centered size="lg" aria-labelledby="termsTitle">
    <Modal.Header closeButton>
      <Modal.Title id="termsTitle">Пользовательское соглашение</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <h5>1. Предмет соглашения</h5>
      <p>
        Настоящее Соглашение регулирует использование пользователем веб-сайта <strong>Varetus.com</strong> и его
        функциональности (включая формы обратной связи). Используя сайт, пользователь подтверждает, что
        ознакомился с Соглашением и обязуется его соблюдать.
      </p>

      <h5>2. Использование сайта</h5>
      <ul>
        <li>Пользователь обязуется предоставлять достоверные сведения при заполнении форм;</li>
        <li>Запрещено нарушать безопасность, пытаться получить несанкционированный доступ, размещать вредоносные данные;</li>
        <li>Запрещено использовать сайт для рассылки спама, мошенничества и иных противоправных действий;</li>
        <li>Владелец сайта вправе ограничить доступ при нарушении Соглашения или угрозе безопасности сервиса.</li>
      </ul>

      <h5>3. Консультации и информация</h5>
      <p>
        Материалы на сайте носят информационный характер и не являются индивидуальной юридической рекомендацией.
        Окончательные выводы и действия формируются с учётом предоставленных пользователем данных и могут требовать
        дополнительной проверки документов и обстоятельств.
      </p>

      <h5>4. Интеллектуальная собственность</h5>
      <p>
        Контент сайта (тексты, графика, логотипы, интерфейс) охраняется правом. Пользователь получает ограниченную
        неисключительную лицензию на личное использование сайта и не вправе копировать или распространять контент
        без разрешения правообладателя.
      </p>

      <h5>5. Ограничение ответственности</h5>
      <p>
        Сайт предоставляется «как есть». Владелец сайта стремится к бесперебойной работе сервиса, однако не
        гарантирует его абсолютную доступность или безошибочность. Ответственность за корректность введённых
        пользователем данных несёт пользователь.
      </p>

      <h5>6. Взаимодействие с третьими лицами</h5>
      <p>
        Сайт может содержать ссылки на сторонние ресурсы. Мы не контролируем их содержание и политику обработки
        данных и не несём ответственность за действия третьих лиц.
      </p>

      <h5>7. Изменения условий</h5>
      <p>
        Владелец сайта может обновлять Соглашение в любой момент для отражения изменений сервиса. Продолжение
        использования сайта означает согласие с обновлёнными условиями.
      </p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onHide}>Закрыть</Button>
    </Modal.Footer>
  </Modal>
);

const LeadForm = () => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [userMess, setUserMess] = useState(false);
  const [resStatus, setResStatus] = useState(false);

  const [validPhoneImg, setValidPhoneImg] = useState(null);
  const [validEmailImg, setValidEmailImg] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [countryCode, setCountryCode] = useState(undefined);

  // NEW: модалки
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  useEffect(() => { const fetchCountry = async () => { const code = await getGeoInfo(); if (code) { setCountryCode(code); } }; fetchCountry(); }, []);

  const getGeoInfo = async () => { try { const response = await axios.get('https://ipapi.co/json/'); return response.data.country_code; } catch (error) { console.error("Error fetching geo information:", error); return null; } };

  const keyUpHandler = () => {
    if (!phone) {
      setValidPhoneImg(null);
      return;
    }
    isValidPhoneNumber(phone) ? setValidPhoneImg(imgCheck) : setValidPhoneImg(imgUnCheck);
    onKeyPressHandler();
  };

  const validateEmail = (email) => {
    const regexp =
      /^([\da-z]){1}([\da-z-.+]){1,19}(@){1}([\da-z.!$%&'*+/=?^_-]{1,14})(\.){1}([a-z]{1,5})$/i;
    return regexp.test(email);
  };

  const keyUpEmailHandler = () => {
    if (!email) {
      setValidEmailImg(null);
      return;
    }
    validateEmail(email) ? setValidEmailImg(imgCheck) : setValidEmailImg(imgUnCheck);
    onKeyPressHandler();
  };

  const [typingTimer, setTypingTimer] = useState(null);
  const doneTypingHandler = () => {
    const data = { name, phone, email, message };
    fetch('/log.php', {
      method: 'post',
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
    });
  };
  const onKeyPressHandler = () => {
    if (typingTimer) clearTimeout(typingTimer);
    setTypingTimer(setTimeout(doneTypingHandler, 3000));
  };

  const onSubmit = (e) => {
    e.preventDefault();

    if (!phone || !name || !message) {
      setResStatus("danger");
      setUserMess("Пожалуйста, проверьте введённые данные и повторите попытку");
      return;
    }

    if (isValidPhoneNumber(phone) || validateEmail(email)) {
      const data = { name, phone, email, message };
      setIsSubmitting(true);

      fetch("/contact.php", {
        method: "post",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((response) => {
          setIsSubmitting(false);

          if (response.status === "success") {
            setName("");
            setPhone("");
            setMessage("");
            window.dataLayer?.push({
              event: "form_submission_success",
              formId: "contactForm",
            });
          }

          if (response.status === "success" || response.status === "danger") {
            setResStatus(response.status);
            setValidPhoneImg(null);
            setUserMess(response.message);
          }
        });
    } else {
      setResStatus("danger");
      setUserMess("Некорректно указан номер телефона или e-mail!");
    }
  };

  const nameChangeHandler = (val) => { setName(val.target.value); onKeyPressHandler(); };
  const emailChangeHandler = (val) => { setEmail(val.target.value); onKeyPressHandler(); };

  return (
    <>
      {/* Модальные окна */}
      <PrivacyPolicyModal show={showPrivacy} onHide={() => setShowPrivacy(false)} />
      <TermsModal show={showTerms} onHide={() => setShowTerms(false)} />

      <Form onSubmit={onSubmit} className="contactForm">
        {resStatus ? <Alert variant={resStatus}>{userMess}</Alert> : ""}

        <Form.Group controlId="formBasicUser" className="form-user form-group">
          <Form.Label>Ваше имя*</Form.Label>
          <Form.Control
            type="text"
            placeholder="Ваше имя"
            onChange={nameChangeHandler}
            onKeyPress={onKeyPressHandler}
            value={name}
            required
          />
        </Form.Group>

        <Form.Group controlId="formBasicEmail" className="form-email form-group">
          <Form.Label>Ваш e-mail*</Form.Label>
          <Form.Control
            type="text"
            placeholder="Ваш e-mail"
            onChange={emailChangeHandler}
            onKeyUp={keyUpEmailHandler}
            onKeyPress={onKeyPressHandler}
            value={email}
            required
          />
          <img src={validEmailImg} className="imgCheckEmail" alt="" />
        </Form.Group>

        <Form.Group controlId="formBasicPhone" className="form-phone form-group">
          <Form.Label>Ваш номер телефона*</Form.Label>
          <PhoneInput
            placeholder="Ваш номер телефона"
            className="form-control"
            value={phone}
            defaultCountry={countryCode}
            international={true}
            onKeyUp={keyUpHandler}
            onKeyPress={onKeyPressHandler}
            onChange={setPhone}
            required
          />
          <img src={validPhoneImg} className="imgCheckPhone" alt="" />
        </Form.Group>

        <Form.Group className="form-group">
          <Form.Label>Ваше сообщение*</Form.Label>
          <textarea
            placeholder="Коротко опишите ваш вопрос..."
            className="form-control"
            value={message}
            onKeyUp={keyUpHandler}
            onKeyPress={onKeyPressHandler}
            onChange={(e) => setMessage(e.target.value)}
            required
          />
        </Form.Group>

        {/* Приписка с ссылками на модалки */}
        <p className="small text-muted mt-2 mb-3">
          Отправляя форму, вы соглашаетесь с нашими{" "}
          <a href="#privacy" onClick={(e) => { e.preventDefault(); setShowPrivacy(true); }}>
            Политикой конфиденциальности
          </a>{" "}
          и{" "}
          <a href="#terms" onClick={(e) => { e.preventDefault(); setShowTerms(true); }}>
            Пользовательским соглашением
          </a>.
        </p>

        <div className="cF-button">
          <Button variant="primary" type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Отправка..." : "Отправить заявку"}
          </Button>
        </div>
      </Form>
    </>
  );
};

export default LeadForm;